import { useApp } from "../../../hooks/useApp"
import { Tabs } from "../../ui/Tabs/Tabs"

interface Props {
  className?: string
}

export const PendantsTabs = ({ className }: Props) => {
  const { mainProduct, activePendantProductId, setActivePendantProductId } = useApp()

  const pendantTabs = mainProduct.metafields.pendantProducts.map((pendantProduct) => ({
    label: pendantProduct.title,
    value: pendantProduct.id,
    onClick: () => { 
      setActivePendantProductId(pendantProduct.id)
    } 
  }))

  return <Tabs className={className} active={activePendantProductId} tabs={pendantTabs} />
}